// From: https://github.com/backstage/backstage/blob/master/plugins/home/src/homePageComponents/WelcomeTitle/WelcomeTitle.tsx

/*
 * Copyright 2021 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import {
  alertApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { Tooltip, Typography } from '@material-ui/core';
import { useEffect, useMemo } from 'react';
import useAsync from 'react-use/lib/useAsync';
import { getTimeBasedGreeting } from './util/timeUtils';

export const PDPWelcomeTitle = () => {
  const identityApi = useApi(identityApiRef);
  const alertApi = useApi(alertApiRef);
  const greeting = useMemo(() => getTimeBasedGreeting(), []);

  const { value: profile, error } = useAsync(() =>
    identityApi.getProfileInfo(),
  );

  useEffect(() => {
    if (error) {
      alertApi.post({
        message: `Failed to load user identity: ${error}`,
        severity: 'error',
      });
    }
  }, [error, alertApi]);

  const getGreetingWithName = (): string => {
    let greetingName = 'Guest';
    if (profile?.displayName) {
      let name = profile.displayName.replace('- C', '').trim();
      if (name.indexOf(',') > 0) {
        name = name.split(',')[1];
        if (name.trim().length > 0) {
          greetingName = name;
        }
      }
    }

    return `${greeting.greeting}, ${greetingName}`;
  };

  return (
    <Tooltip title={greeting.tooltip}>
      <Typography component="span" variant="inherit">
        {getGreetingWithName()}
      </Typography>
    </Tooltip>
  );
};
